import React, { useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
} from "rn-responsive-styles";
import { AppFontStyle } from "../../../../../styles/AppFontStyle";
import { AppColors } from "../../../../../utility/AppColors";

interface LiveParticipantsChatProps {
  isExpandChat: boolean;
  setIsExpandChat: (value: boolean) => void;
}

const LiveParticipantsChat: React.FC<LiveParticipantsChatProps> = ({
  isExpandChat,
  setIsExpandChat,
}) => {
  const styles = useStyles();
  const [selectedTab, setSelectedTab] = useState("Players");
  const tabs = ["Players", "Shout caster", "Moderator"];

  return (
    <View style={styles.container}>
      {/* Header and Tabs */}
      <View style={{ paddingVertical: 7, paddingHorizontal: 10 }}>
        <Text style={[AppFontStyle.BOLD_ANYBODY_12, { marginBottom: 6 }]}>
          Live Participants Chat
        </Text>
        <View style={styles.tabsContainer}>
          {tabs.map((tab, index) => (
            <TouchableOpacity
              key={index}
              style={[
                styles.tabButton,
                selectedTab === tab && styles.selectedTab,
              ]}
              onPress={() => setSelectedTab(tab)}
            >
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_12,
                  { textAlign: "center" },
                ]}
              >
                {tab}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
      </View>

      {/* Chat Container with Coming Soon Overlay */}
      <View style={styles.chatContainer}>
        <View style={styles.overlay}>
          <Text
            style={[AppFontStyle.BOLD_ANYBODY_16, { color: AppColors.white }]}
          >
            {selectedTab}
          </Text>
          <Text style={[AppFontStyle.BOLD_ANYBODY_24, { color: "#FACC15" }]}>
            Coming Soon
          </Text>
        </View>
      </View>
    </View>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    container: {
      backgroundColor: AppColors.grayColor_282828,
      borderRadius: 10,
      borderWidth: 1,
      borderColor: AppColors.purple_453B50,
      height: 480, // Consistent height with match preview + controls
    },
    tabsContainer: {
      flexDirection: "row",
      gap: 6,
    },
    tabButton: {
      padding: 8,
      borderRadius: 5,
      flex: 0.33,
      backgroundColor: AppColors.blackTrans_000000a8,
    },
    selectedTab: {
      backgroundColor: AppColors.sidebarBorder_374151,
    },
    chatContainer: {
      flex: 1,
      backgroundColor: AppColors.sidebarBackground_111827,
      position: "relative",
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
    },
    overlay: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      justifyContent: "center",
      alignItems: "center",
      zIndex: 10,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {},
  }
);

export default LiveParticipantsChat;
